export enum MenuListTypeEnum {
	HOME = 'home',
	SERVICES = 'servicos',
	BOOKING = 'agendamento',
	HEALTH_CARD = 'carteirinha',
	PERKS = 'beneficios',
	NETWORK = 'rede',
}
